module.exports = __webpack_public_path__ + "img/morocco.7e9a4d33.svg";